var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container__content"},[_c('div',{staticClass:"free-auth"},[_c('pulse-loader',{attrs:{"color":"#000","size":"10px"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }